import { render, staticRenderFns } from "./NewSubject.vue?vue&type=template&id=24b3e62c&"
import script from "./NewSubject.vue?vue&type=script&lang=js&"
export * from "./NewSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports